import { Box } from "@mui/material";
import { PartDetails } from "../../../../explorer/types/SpareParts/PartDetails";
import { ManufacturerLogo } from "../../ManufacturerLogo/ManufacturerLogo";
import {
    BoxContent,
    PartDetailsCode,
    PartHeaderBox,
} from "./PartDetails.style";
import { AppIconsReplaced } from "../../AppIcons";

const PartHeader: React.FC<React.PropsWithChildren<PartDetails>> = (
    props: React.PropsWithChildren<PartDetails>
) => {
    const partDetails = props;
    return (
        <PartHeaderBox>
            <BoxContent>
                {partDetails?.manufacturerCompanyCode && (
                    <ManufacturerLogo
                        manufacturer={partDetails?.manufacturerCompanyCode}
                    />
                )}
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    {partDetails.lastReplacementPartCodes !== null ? (
                        <AppIconsReplaced />
                    ) : null}
                    <PartDetailsCode variant="h5">
                        {`${
                            partDetails?.lastReplacementPartCodes ??
                            partDetails.code
                        } - ${partDetails?.partDescriptions[0].description}`}
                    </PartDetailsCode>
                </Box>
            </BoxContent>
        </PartHeaderBox>
    );
};

export default PartHeader;
